import { ColorIndex } from "@/constants/ChartColorIndex";
import { EChartsOption, LegendComponentOption } from "echarts";
import ReactECharts from "echarts-for-react";
import { PieDataItemOption } from "echarts/types/src/chart/pie/PieSeries";
import { FC } from "react";
import { ChartPosition } from '@/utilities/ChurnCustomer';

export interface ChartOptions {
  chartLegend?: Partial<LegendComponentOption>;
  chartTitle?: string;
  chartTitlePosition?: ChartPosition;
  color?: string[];
  containerHeight: string;
  pieCenterLabel?: string;
  pieCenterText?: string;
  position?: ChartPosition;
}

interface PieDataItem extends PieDataItemOption {
  labelText: string;
}

interface TierProgressPieChartProps {
  chartOptions: ChartOptions;
  seriesData: PieDataItem[];
}

export const TierProgressPieChart: FC<TierProgressPieChartProps> = ({
  chartOptions,
  seriesData,
}) => {
  const options: EChartsOption = {
    color: chartOptions.color ?? ColorIndex,
    graphic: {
      left: chartOptions.position ?? "center",
      style: {
        rich: {
          customerLabel: {
            fontSize: 14,
            fontWeight: "normal",
          },
          totalCount: {
            fontSize: 35,
            fontWeight: "bold",
          },
        },
        text: [
          `{totalCount|${chartOptions.pieCenterText ?? "-"}}`,
          `{customerLabel|${chartOptions.pieCenterLabel ?? "Customers"}}`,
        ].join("\n"),
        textAlign: 'center',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any, // necessary because we get error on textAlign property which actually works,
      top: "center",
      type: "text",
    },
    legend: {
      ...chartOptions.chartLegend,
      borderRadius: chartOptions.chartLegend?.borderRadius ?? 1,
      bottom: chartOptions.chartLegend?.bottom ?? "0%",
      itemGap: chartOptions.chartLegend?.itemGap ?? 12,
      itemHeight: chartOptions.chartLegend?.itemHeight ?? 10,
      itemWidth: chartOptions.chartLegend?.itemWidth ?? 10,
      left: chartOptions.chartLegend?.left ?? "left",
      orient: chartOptions.chartLegend?.orient ?? "vertical",
      selectedMode: chartOptions.chartLegend?.selectedMode ?? false,
      selectorLabel: chartOptions.chartLegend?.selectorLabel ?? {
        fontSize: 12,
      },
      top: chartOptions.chartLegend?.top ?? "30px",
    },
    series: [
      {
        data: seriesData,
        label: {
          formatter: (params) => (params.data as PieDataItem).labelText,
          position: "outer",
          rich: {
            bold: {
              fontSize: 12,
              fontWeight: "bold",
            },
          },
        },
        radius: ["53%", "80%"],
        startAngle: 90,
        type: "pie",
      },
    ],
    title: {
      left: chartOptions.chartTitlePosition ?? "center",
      text: chartOptions.chartTitle ?? "",
    },
    tooltip: {
      showContent: true,
    },
  };


  return (
    <ReactECharts
      option={options}
      style={{
        height: chartOptions.containerHeight ?? "392px",
        width: "100%",
      }}
    />
  );
};
